import React from "react";

import Grid from "@material-ui/core/Grid";

import { Field, FormSpy } from "react-final-form";
import { TextField } from "final-form-material-ui";

import {
  List,
  MountEntity,
  CrudForm,
  useParentChildrenNavigation,
  CrudTabs,
  CrudRoute,
  ListApi,
  FormApi,
  DatePicker,
  Autocomplete,
  loopback,
  Filter,
  autocompleteHelpers,
} from "elentari";

import {
  evalAptActivityApi,
  evalAptRangeApi,
  evalAptInstanceApi,
  clienteApi as customerApi,
} from "../../services/Api";

import ReferenceTable from "../../components/ReferenceTable";

import moment from "moment";

const { loopbackFilters } = loopback;

function EvalAptFilter(props) {
  return (
    <Filter
      formatFilters={{
        customerId: (value) => value.id,
        activityId: (value) => value.id,
      }}
      labels={{ find: "Buscar", clear: "Limpar" }}
    >
      <Grid spacing={24} container>
        <Grid item xs>
          <Field
            label="Cliente"
            loadOptions={loadCustomers}
            component={Autocomplete}
            name="customerId"
          />
        </Grid>
        <Grid item xs>
          <Field
            label="Atividade"
            loadOptions={loadActivities}
            component={Autocomplete}
            name="activityId"
          />
        </Grid>
      </Grid>
    </Filter>
  );
}

export function EvalAptInstanceList(props) {
  const listOptions = {
    defaultOrder: "dateTaken",
    fields: {
      customer: {
        label: "Cliente",
      },
      activity: {
        label: "Atividade",
      },
      value: {
        label: "Valor",
      },
      dateTaken: {
        label: "Data",
        format: (date) => (date ? moment(date).format("DD/MM/YYYY") : ""),
      },
    },
  };

  const classifyValue = (
    value,
    { ord, levelBest, levelAboveAvg, levelAvg, levelBelowAvg, levelWorst }
  ) => {
    if (ord) {
      // Ascending order
      if (value <= levelBest) return "Excelente";
      else if (value <= levelAboveAvg) return "Bom";
      else if (value <= levelAvg) return "Médio";
      else if (value <= levelBelowAvg) return "Regular";
      else return "Fraco";
    } else {
      // Descending order
      if (value >= levelBest) return "Excelente";
      else if (value >= levelAboveAvg) return "Bom";
      else if (value >= levelAvg) return "Médio";
      else if (value >= levelBelowAvg) return "Regular";
      else return "Fraco";
    }
  };

  const getPageDecorator = async ({ getPage }) => {
    const items = await getPage();
    if (!items) return;
    const promises = items.map(async (item) => {
      let ret = {
        ...item,
      };

      // Join customer
      const customer = await customerApi.getOne(item.customerId);
      if (customer.ok) {
        ret.customer = customer.data.nome;
        delete ret.customerId;
      }

      // Join activity
      const activity = await evalAptActivityApi.getOne(item.activityId);
      if (activity.ok) {
        ret.activity = activity.data.name;
        delete ret.activityId;
      }

      // Join range
      const range = await evalAptRangeApi.getList({
        where: {
          activityId: item.activityId,
          sex: customer.genero === "M" ? true : false,
        },
        order: "minAge asc",
      });
      if (range.ok) {
        const find = range.data.find(
          (r) => item.ageTaken >= r.minAge && item.ageTaken < r.maxAge
        );

        const classification = classifyValue(ret.value, find);

        ret.value = `${ret.value} (${classification})`;
      }

      return ret;
    });

    return Promise.all(promises);
  };

  return (
    <ListApi getPageDecorator={getPageDecorator} api={evalAptInstanceApi}>
      {({ getPage, getCount, handleDelete }) => (
        <div>
          <EvalAptFilter />
          <List
            {...props}
            withPaper
            labelNew="Novo"
            deleteItem={handleDelete}
            onClickEdit={(item) =>
              props.history.push(`/eval-apt-instance/${item.id}`)
            }
            onClickNew={() => props.history.push("/eval-apt-instance/new")}
            getPage={getPage}
            getCount={getCount}
            listOptions={listOptions}
          />
        </div>
      )}
    </ListApi>
  );
}

export function EvalAptInstanceForm(props) {
  const validate = (values) => ({
    customer: values.customer ? undefined : "Obrigatório",
    activity: values.activity ? undefined : "Obrigatório",
    value: values.value ? undefined : "Obrigatório",
    ageTaken: values.ageTaken ? undefined : "Obrigatório",
    dateTaken: values.dateTaken ? undefined : "Obrigatório",
  });

  const submitDecorator = async ({ data, id, handleSubmit }) => {
    const result = await handleSubmit({
      id,
      data: {
        ...data,
        customer: undefined,
        customerId: data.customer.id,
        activity: undefined,
        activityId: data.activity.id,
        value: parseInt(data.value),
        ageTaken: parseInt(data.ageTaken),
        dateTaken: data.dateTaken,
        reference: undefined,
      },
    });
    return result;
  };

  const getItem = async () => {
    return MountEntity(props, evalAptInstanceApi.getOne)
      .populate(({ data, id }) => ({
        customer: customerApi.getOne(data.customerId),
        activity: evalAptActivityApi.getOne(data.activityId),
      }))
      .clean(["customerId", "activityId"])
      .map((data) => ({
        ...data,
        customer: autocompleteHelpers.toOption("nome", "genero")(data.customer),
        activity: autocompleteHelpers.toOption("name")(data.activity),
      }))
      .getItem();
  };

  return (
    <FormApi
      api={evalAptInstanceApi}
      submitDecorator={submitDecorator}
      {...props}
    >
      {({ handleSubmit }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container direction="column" spacing={16}>
            <Grid item>
              <Grid container spacing={16}>
                <Grid item xs={12}>
                  <Field
                    label="Cliente"
                    loadOptions={loadCustomers}
                    component={Autocomplete}
                    name="customer"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    label="Atividade"
                    loadOptions={loadActivities}
                    component={Autocomplete}
                    name="activity"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormSpy component={ReferenceTable} />
                </Grid>
                <Grid item sm={3} xs={12}>
                  <Field
                    label="Valor"
                    type="number"
                    component={TextField}
                    name="value"
                  />
                </Grid>
                <Grid item sm={3} xs={12}>
                  <Field
                    label="Idade"
                    type="number"
                    component={TextField}
                    name="ageTaken"
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Field
                    fullWidth
                    component={DatePicker}
                    label="Data da Avaliação"
                    name="dateTaken"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}

const loadCustomers = async (inputValue) => {
  const response = await customerApi.getList({
    where: {
      nome: loopbackFilters.regexp(inputValue),
    },
    order: "nome asc",
    limit: 40,
  });

  if (response.ok)
    return response.data.map(autocompleteHelpers.toOption("nome", "genero"));

  return [];
};

const loadActivities = async (inputValue) => {
  const response = await evalAptActivityApi.getList({
    where: {
      name: loopbackFilters.regexp(inputValue),
    },
    order: "name asc",
    limit: 40,
  });

  if (response.ok)
    return response.data.map(autocompleteHelpers.toOption("name"));

  return [];
};

export function EvalAptInstanceTabs(props) {
  const { current, navigate } = useParentChildrenNavigation(props, {
    mainPath: "eval-apt-instance",
  });
  return (
    <CrudTabs
      {...props}
      mainPath="eval-apt-instance"
      current={current}
      tabs={[{ value: "", label: "Avaliação de Aptidão Física" }]}
      navigate={navigate}
    >
      <div>
        <CrudRoute render={() => <EvalAptInstanceForm {...props} />} />
      </div>
    </CrudTabs>
  );
}
